var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcContact16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.915 8c1.7 0 3-1.3 3-3s-1.3-3-3-3-3 1.3-3 3 1.4 3 3 3m0-4c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .5-1 1-1M7.915 9c-2.4 0-4.4 1.7-4.9 4-.1.5.3 1 .9 1s1-.5 1.2-1c.4-1.2 1.5-2 2.8-2s2.4.8 2.8 2c.2.5.6 1 1.2 1s1-.5.9-1c-.4-2.3-2.5-4-4.9-4"
})));
export default SvgIcContact16;